import { store } from '../store';

// sessionStorage is already per-tab, but a SMART-on-FHIR embedded launch can run several launches within one EHR
// browsing context. Suffixing the key with the per-launch browserTabId — minted at /fhir/r4/launch, carried in the
// encrypted Smart_SessionState cookie and hydrated into the store from /api/auth/status — keeps each launch's value
// isolated. A standard OIDC session has no launch browserTabId, so a stable fallback GUID is minted once per tab and
// reused, so a write and a later read within the same tab still resolve to the same key.

// Per-tab fallback identifier for non-SMART sessions, persisted (not held in the store, which would flip the SMART
// launch context to a value) so it survives reloads and stays identical across a write/read pair in the same tab.
const FALLBACK_BROWSER_TAB_ID_KEY = 'zb_browser_tab_id';

function newGuid(): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function')
        return crypto.randomUUID();
    // crypto.randomUUID needs a secure context; fall back to an RFC 4122 v4-shaped id where it is unavailable.
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0;
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
}

function fallbackBrowserTabId(): string {
    let id = sessionStorage[FALLBACK_BROWSER_TAB_ID_KEY];
    if (!id || id === 'undefined') {
        id = newGuid();
        sessionStorage[FALLBACK_BROWSER_TAB_ID_KEY] = id;
    }
    return id;
}

export function tabScopedKey(key: string): string {
    const browserTabId = store.state.browserTabId || fallbackBrowserTabId();
    return `${key}_${browserTabId}`;
}
